/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useEffect, useState } from "react";

type Props = {
  url: string;
  className?: string;
  svgAriaHidden?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const hideInlineSvg = (markup: string) => {
  const document = new DOMParser().parseFromString(markup, "image/svg+xml");
  const svg = document.documentElement;

  if (svg.tagName.toLowerCase() !== "svg") {
    return markup;
  }

  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");

  return new XMLSerializer().serializeToString(svg);
};

export const SvgInline = ({ svgAriaHidden, url, ...rest }: Props) => {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    fetch(url)
      .then((res) => res.text())
      .then((markup) => setSvg(svgAriaHidden ? hideInlineSvg(markup) : markup));
  }, [svgAriaHidden, url]);

  if (!svg) {
    return null;
  }

  return <div {...rest} dangerouslySetInnerHTML={{ __html: svg }} />;
};
